import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

/** Разбивка вклада резидента — единственный источник правды (SQL resident_contribution). */
export type ResidentContribution = {
  drives: number;
  quick_start: boolean;
  coffee_confirmed: number;
  coffee_sent: number;
  events_held: number;
  event_attendance: number;
  referrals: number;
  circles_hosted: number;
  circles_joined: number;
  people_came: number;
  cities: number;
};

export function useResidentContribution(userId: string | undefined) {
  return useQuery({
    queryKey: ["resident-contribution", userId],
    enabled: !!userId,
    queryFn: async (): Promise<ResidentContribution | null> => {
      const { data, error } = await supabase.rpc("resident_contribution", { uid: userId! });
      if (error) throw error;
      const row = (data as ResidentContribution[] | null)?.[0];
      return row ?? null;
    },
  });
}

export const STATUS_TIERS = [
  { min: 0, key: "yabanci", label: "Yabancı", gradientFrom: "#0D5C58", gradientTo: "#1ABFB8" },
  { min: 150, key: "vatandas", label: "Vatandaş", gradientFrom: "#9E4A15", gradientTo: "#E5722A" },
  { min: 450, key: "sultan", label: "Sultan", gradientFrom: "#7A1810", gradientTo: "#E63E2A" },
] as const;

export type StatusTier = (typeof STATUS_TIERS)[number];

export function statusForDrives(drives: number): StatusTier {
  let tier: StatusTier = STATUS_TIERS[0];
  for (const t of STATUS_TIERS) {
    if (drives >= t.min) tier = t;
  }
  return tier;
}

export function tierByKey(key: string | null | undefined): StatusTier | null {
  if (!key) return null;
  return STATUS_TIERS.find((t) => t.key === key) ?? null;
}

export function resolveStatus(
  drives: number,
  manualOverride: string | null | undefined,
): StatusTier {
  return tierByKey(manualOverride) ?? statusForDrives(drives);
}
